import { render, staticRenderFns } from "./HelpJuice.vue?vue&type=template&id=4b768e86&"
import script from "./HelpJuice.vue?vue&type=script&lang=js&"
export * from "./HelpJuice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports